/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<4c4d561731d8e62b3f28628027b3b94c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpLayoutConnectElementPages = "APPROVALS" | "CREATE_REQUEST" | "HELP_CENTER" | "MY_REQUEST" | "PORTAL" | "PROFILE" | "VIEW_REQUEST" | "%future added value";
export type HelpLayoutConnectElementType = "detailsPanels" | "footerPanels" | "headerAndSubheaderPanels" | "headerPanels" | "optionPanels" | "profilePagePanel" | "propertyPanels" | "requestCreatePanel" | "subheaderPanels" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type connectElementFragment$data = {
  readonly connectElementPage: HelpLayoutConnectElementPages;
  readonly connectElementType: HelpLayoutConnectElementType;
  readonly " $fragmentType": "connectElementFragment";
};
export type connectElementFragment$key = {
  readonly " $data"?: connectElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"connectElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "connectElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "connectElementPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "connectElementType",
      "storageKey": null
    }
  ],
  "type": "HelpLayoutConnectElement",
  "abstractKey": null
};

(node as any).hash = "88a04fa7e931050b52a2fe8d7668fe89";

export default node;
